import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, isDirty, isValid, reset, change } from 'redux-form';
import ChangeDeliveryDialog from './LoadPurchaseOrderDialog';
import { IApplicationState } from 'ducks/reducers';
import { selectors as purchaseOrdersSelectors } from 'ducks/purchaseOrderEnquiry/purchaseOrder';
import { selectors as staffSelectors } from 'ducks/staff';

const params = new URLSearchParams(location.search);

const mapStateToProps = (state: IApplicationState) => ({
  dirty: isDirty('LoadPurchaseOrderForm')(state),
  values: getFormValues('LoadPurchaseOrderForm')(state),
  isValid: isValid('LoadPurchaseOrderForm')(state),
  selectedPurchaseOrder: purchaseOrdersSelectors.selected(state)?.PurchaseOrder ?? params.get('PurchaseOrder'),
  currentUserId: staffSelectors.id(state) ? staffSelectors.id(state) : ''
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    resetForm: () => reset('LoadPurchaseOrderForm'),
    changeFormFieldValue: (fieldName: string, fieldValue: any) => change('LoadPurchaseOrderForm', fieldName, fieldValue),
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ChangeDeliveryDialog);
